import {Component, Input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatMenuTrigger} from '@angular/material/menu';

@Component({
    selector: 'app-emoji-menu',
    templateUrl: './emoji-menu.component.html',
    styleUrl: './emoji-menu.component.scss'
})
export class EmojiMenuComponent {
    @Input({required: true}) formControl!: FormControl;
    @Input() ckEditorField: any;
    @Input() htmlInput: HTMLInputElement | HTMLTextAreaElement | undefined;

    addEmoji(event: any, menuItem: any): void {
        // menuItem.closeMenu()

        if (this.ckEditorField) {
            const model = this.ckEditorField.model;

            const selection = model.document.selection;

            // Use the writer to insert text at the current caret position
            model.change((writer: any): void => {
                writer.insertText(event.emoji.native, selection.getFirstPosition());
            });
        } else if (this.htmlInput) {
            const currentValue: string = this.htmlInput.value;
            const startPos: number = this.htmlInput.selectionStart || 0;
            const endPos: number = this.htmlInput.selectionEnd || startPos;

            // Insert the new text
            this.htmlInput.value =
                currentValue.slice(0, startPos) + event.emoji.native + currentValue.slice(endPos);

            this.htmlInput.dispatchEvent(new Event('input'));
        } else {
            const text = this.formControl.value + event.emoji.native;
            this.formControl.patchValue(text);
            this.formControl.updateValueAndValidity();
        }

    }

    stopClose(event: any): void {
        event.stopPropagation()
    }

    closeMenu(trigger: MatMenuTrigger): void {
        trigger.closeMenu();
    }
}
